module.exports = __webpack_public_path__ + "ico/ico BID.png";